import { z } from 'zod';

export const programReviewsSchema = z
  .object({
    ratings: z
      .object({
        productReviews: z.array(
          z.object({
            createdAt: z.string(),
            stars: z.number(),
            content: z.string(),
            consumer: z
              .object({
                name: z.string().optional(),
                displayName: z.string().optional(),
              })
              .transform((data) => ({ name: data.name ? data.name : data.displayName })),
          })
        ),
      })
      .nullable(),
  })
  .transform((data) => data.ratings?.productReviews ?? []);

export type ProgramReviewsResponse = z.input<typeof programReviewsSchema>;
export type ProgramReviews = z.infer<typeof programReviewsSchema>;
export type ProgramReview = ProgramReviews[number];
